'use client';

import { isInitialized } from '@fullstory/browser';

import { useState } from 'react';
import { useInterval } from 'react-use';

export function useFullstoryInitialized(): boolean {
	const [initialized, setInitialized] = useState(false);
	const [delay, setDelay] = useState<number | null>(1);

	useInterval(() => {
		const newInitialized = isInitialized();
		if (!newInitialized) {
			let newDelay: number;
			if (delay === null) {
				newDelay = 1;
			} else {
				newDelay = Math.max(delay * 2, 100);
			}
			setDelay(newDelay);
			return;
		}

		setInitialized(true);
		setDelay(null);
	}, delay);

	return initialized;
}
